import { COOKIE_NAMES } from "@/lib/constants/config";
import { get_cookie } from "@/lib/browser/cookie-utils";

const tapfiliate_api_url = "/api/tapfiliate/map-click-to-order";

export const link_tapfiliate_click_to_order = async (
  order_id: number,
): Promise<boolean> => {
  try {
    const tapfiliate_click_id_cookie = get_cookie(
      COOKIE_NAMES.TAPFILIATE_CLICK_ID,
    );
    if (tapfiliate_click_id_cookie) {
      const wp_response = await fetch(tapfiliate_api_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          order_id,
          click_id: tapfiliate_click_id_cookie,
        }),
      });

      if (!wp_response.ok) {
        const error_text = await wp_response.text();
        console.error("Tapfiliate API error", {
          endpoint: tapfiliate_api_url,
          method: "POST",
          status: wp_response.status,
          response: error_text,
          timestamp: new Date().toISOString(),
        });
        return false;
      }
      return true;
    }
    return false;
  } catch (error) {
    console.error("Tapfiliate Service - HTTP request failed", {
      endpoint: tapfiliate_api_url,
      method: "POST",
      error: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
      timestamp: new Date().toISOString(),
    });
    return false;
  }
};
